module.exports = __webpack_public_path__ + "media/Mobile_OUT.c3b63ff5.mp4";